import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { useCountry } from './../CountryContext';
import ReportsSection from "../../components/ReportDropdown7"

const Solutions = () => {
  const SMMEsOptions = [
    // ... (keep the existing SMMEsOptions array unchanged)
  ];

  const { selectedCountry } = useCountry();
  const [reportSelections, setReportSelections] = useState({
    COUNTRY: "-",
    REGION: "-",
    DISTRICT: "-",
    MUNICIPALITY: "-",
    SMMEs: "-",
    "VALUE CHAIN": "-",
    PROJECT: "-",
    "USER TYPE": "-"
  });

  const handleReportDropdownChange = (type, value) => {
    setReportSelections(prev => {
      const newSelections = {
        ...prev,
        [type]: value
      };
      
      if (type === 'COUNTRY') {
        newSelections.REGION = "-";
        newSelections.DISTRICT = "-";
        newSelections.MUNICIPALITY = "-";
      }
      
      return newSelections;
    });
  };

  return (
    <div className="bg-white md:pt-5 mt-2 pb-2 md:pb-5 pt-3">
      <div className="md:px-20 px-4">
        <div className="flex justify-between items-center">
          <h2 className="md:text-[36px] text-[10px] capitalize text-[#152C24] font-bold">
            <span className="text-[#979797] capitalize">SERVICES | </span>{selectedCountry?.name || 'South Africa'}
          </h2>
          <div>
            <h1 className="md:text-[20px] text-[8px] font-extrabold md:mb-2">USER NUMBER</h1>
            <div className="flex w-fit">
              <button
                className={`xl:w-[250px] lg:w-[160px] md:w-[90px] w-[70px] h-[25px] md:h-[53px] bg-[#152C24] text-white font-medium flex items-center px-1 rounded-l-[5px]`}>
                <input className="md:text-[18px] text-[8px] md:px-2 bg-transparent outline-none placeholder-white" placeholder="XXXXXXXXX"/>
              </button>
              <div
                className="w-[20px] h-[25px] md:h-[53px] md:w-[50px] bg-[#EEB527] text-white flex justify-center items-center rounded-r-[5px] -ml-2 z-30 cursor-pointer"
              >
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1747251939/Expand_right_wbmjno.png"
                  alt="expand"
                  className="w-3 h-[12px] md:w-6 md:h-[24px]"
                />
              </div>
            </div>
            <p className="md:text-[14px] text-[8px] font-normal mt-1 text-black">
              Insert ID Number
            </p>
          </div>
        </div>
        
        <ReportsSection
          values={reportSelections}
          onChange={handleReportDropdownChange}
          smmesOptions={SMMEsOptions}
        />

<div className="relative w-full h-[150px] md:h-[650px]">
  {/* Background image */}
  <img
    src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752181532/image_5_fquiny.png"
    alt="Securing Agriculture in Namibia"
    className="w-full h-full object-cover md:rounded-lg rounded-md transition-opacity duration-500"
  />
  
  {/* Overlay icon centered */}
  <div className="absolute inset-0 flex items-center justify-center">
    <img
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1743776596/image_1502_utmsek.png"
      alt="Farm icon"
      className="w-16 h-16 md:w-32 md:h-32 object-contain"
    />
  </div>
</div>
        
        <div className="md:mt-6 mt-4">
          {/* Header with time */}
          <div className="flex items-start justify-between mb-2">
            <div className="md:text-[32px] text-[10px] text-[#979797] font-bold">
              FARMING TIPS | <span className="text-black"> Beans</span>
            </div>
            <div>
              <p className="md:text-[24px] text-[8px] font-normal md:ml-10">April 13, 2025</p>
              <div className="flex items-center md:text-[24px] text-[8px] text-[#155528] font-normal">
                <img
                  src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752158165/Time_progress_light_sufu81.png"
                  alt="Time"
                  width={16}
                  height={16}
                  className="mr-1 md:mr-2 md:w-6 md:h-6"
                />
                2 Minutes read
              </div>
            </div>
          </div>

          {/* Main Title */}
    
          <div className="md:text-[32px] -mt-2 mb-8  text-[10px] text-[#979797] font-semibold">
          CHICKEN | <span className="text-black"> Layers</span>
            </div>
            <h1 className="md:text-[32px] text-[10px] font-normal text-black mb-8">
            Farming tips for successful chicken layer management:
          </h1>
          <h1 className="md:text-[32px] text-[10px] font-normal text-black mb-6">
            Farming Tips for Successful Keeping of Layer Chickens
          </h1>
          {/* Tips */}
          <div className="space-y-4 md:space-y-6 md:text-[32px] text-[10px]">
            <div>
              <strong className="text-black">✅ 1. Choose the Right Breed</strong>
              <p>Go for high-performing layer breeds such as ISA Brown, Hy-Line, Lohmann, or Kuroiler hybrids, depending on your environment and goals.</p>
              <p className="md:mt-6">Start with healthy, vaccinated day-old chicks from a certified hatchery.</p>
            </div>

            <div>
              <strong className="text-black">✅ 2. Housing and Environment</strong>
              <p>Build a well-ventilated, secure poultry house that keeps birds safe from predators, wind, and rain.</p>
              <p className="md:mt-6">Maintain 1.5–2 sq. ft per bird in the laying house to prevent overcrowding.</p>
              <p className="md:mt-6">Provide clean litter (wood shavings or straw) and replace it regularly to control disease.</p>
            </div>

            <div>
              <strong className="text-black">✅ 3. Temperature & Lighting</strong>
              <p>Keep chicks warm during brooding (first 4–6 weeks) using charcoal jikos, infrared lamps, or gas brooders.</p>
              <p className="md:mt-6">Layers need 14–16 hours of light per day for optimal egg production—add artificial light if needed.</p>
            </div>

            <div>
              <strong className="text-black">✅ 4. Feeding</strong>
              <p>Provide balanced layer feed:</p>
        
        <p className="md:mt-6 ">    Starter feed: 0–6 weeks </p>
           <p className="md:mt-6 ">     Grower feed: 6–18 weeks</p>
          <p className="md:mt-6 ">      Layer feed: from 18 weeks onward</p>
       
              <p className="md:mt-6">Ensure constant access to clean drinking water—one of the most critical factors in egg laying.</p>
              <p className="md:mt-6">Supplement with calcium (e.g., oyster shells) to strengthen eggshells.</p>
            </div>

            <div>
              <strong className="text-black">✅ 5. Health & Vaccination</strong>
              <p>Follow a vaccination schedule for diseases like Newcastle, Gumboro, Marek's, and Fowl Pox.</p>
              <p className="md:mt-6">Deworm regularly and maintain strict biosecurity:</p>
              <ul className="space-y-6">
                <li>Limit visitors</li>
                <li>Disinfect equipment</li>
                <li>Keep rodents and wild birds away</li>
              </ul>
            </div>

            <div>
              <strong className="text-black">✅ 6. Nesting and Egg Collection</strong>
              <p>Provide 1 nest box per 5 hens with clean, dry bedding.</p>
              <p className="md:mt-6">Collect eggs 2–3 times per day to reduce breakages and chances of contamination.</p>
              <p className="md:mt-6">Store eggs in a cool, dry place—do not wash unless absolutely necessary.</p>
            </div>

            <div>
              <strong className="text-black">✅ 7. Record Keeping</strong>
              <p>Monitor and record:</p>
              <ul  className="space-y-6 md:mt-6 mt-2">
                <li>Daily egg production</li>
                <li>Feed consumption</li>
                <li>Mortality rates</li>
                <li>Health and medication history</li>
              </ul>
            </div>

            <div>
              <strong className="text-black">✅ 8. Cull Non-Productive Birds</strong>
              <p>After 12–18 months, layer productivity declines. Cull and sell low-performing birds to maintain profitability.</p>
            </div>

            <div>
              <strong className="text-black">✅ 9. Marketing</strong>
              <p>Identify buyers early—hotels, local shops, markets, or direct to consumers.</p>
              <p className="md:mt-6">Ensure proper cleaning and packaging of eggs for better market value.</p>
            </div>

            <div>
              <strong className="text-black">✅ 10. Hygiene is Everything</strong>
              <p>Clean feeders and drinkers daily</p>
              <p className="md:mt-6">Disinfect houses regularly</p>
              <p className="md:mt-6">Rotate litter and manage waste to prevent disease buildup</p>
            </div>
          </div>

          <div className="flex justify-between items-center mt-6 md:mt-12">
            <div className="flex gap-1 md:gap-2 items-center">
              <h1 className="md:text-[24px] text-[8px] font-normal">Reviews & Ratings</h1>
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752159820/image_1786_qgnngy.png" alt="link" className="w-[16px] h-[16px] md:w-[48px] md:h-[48px]"/>
            </div>
            <div className="flex gap-1 md:gap-2 items-center">
              <h1 className="md:text-[24px] text-[8px] font-normal">WhatsApp us</h1>
              <img src="https://res.cloudinary.com/dzngpgki4/image/upload/v1752160024/image_1785_bsrl4k.png" alt="link" className="w-[16px] h-[16px] md:w-[48px] md:h-[48px]"/>
            </div>
          </div>
        </div>
      </div>

      <div className="md:h-8 h-4"></div>
    </div>
  );
};

export default Solutions;